"use client"

import { useRef } from "react"
import type { PublishedLegalDocument } from "../content/content-types.ts"
import { LegalDocumentContent } from "./legal-document.tsx"
import styles from "./my-legal-dialogs.module.css"
import rowStyles from "./my-support.module.css"

export type MyLegalDocuments = {
  readonly privacy: PublishedLegalDocument
  readonly service: PublishedLegalDocument
}

type LegalDialogActionProps = {
  readonly document: PublishedLegalDocument
  readonly kind: keyof MyLegalDocuments
  readonly label: string
}

const LegalDialogAction = ({ document, kind, label }: LegalDialogActionProps) => {
  const dialogRef = useRef<HTMLDialogElement>(null)
  const triggerRef = useRef<HTMLButtonElement>(null)
  const titleId = `my-legal-${kind}-title`

  const openDialog = (): void => {
    dialogRef.current?.showModal()
  }

  const closeDialog = (): void => {
    dialogRef.current?.close()
  }

  const restoreTriggerFocus = (): void => {
    triggerRef.current?.focus()
  }

  return (
    <li>
      <button className={rowStyles["myLinkButton"]} onClick={openDialog} ref={triggerRef} type="button">
        {label}
      </button>
      <dialog aria-labelledby={titleId} className={styles["legalDialog"]} data-legal-document={kind} onClose={restoreTriggerFocus} ref={dialogRef}>
        <header className={styles["legalDialogHeader"]}>
          <h2 className={styles["legalDialogTitle"]} id={titleId}>
            {document.title}
          </h2>
          <button aria-label="닫기" className={`${styles["legalDialogClose"]} button secondary`} data-legal-dialog-close onClick={closeDialog} type="button">
            <span aria-hidden="true">×</span>
          </button>
        </header>
        {/* biome-ignore lint/a11y/noNoninteractiveTabindex: The viewport-bounded legal body owns scrolling and must be keyboard reachable. */}
        <section aria-label={`${document.title} 본문`} className={styles["legalDialogScroll"]} data-legal-dialog-scroll tabIndex={0}>
          <LegalDocumentContent document={document} />
        </section>
      </dialog>
    </li>
  )
}

export const MyLegalDialogs = ({ documents }: { readonly documents: MyLegalDocuments }) => (
  <>
    <LegalDialogAction document={documents.service} kind="service" label="이용약관" />
    <LegalDialogAction document={documents.privacy} kind="privacy" label="개인정보처리방침" />
  </>
)
